import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/explore.scss';

function DiscoverySection({
	eyebrow,
	title,
	intro,
	linkTo,
	linkLabel,
	alt = false,
	children,
	id,
}) {
	return (
		<section className={`discovery-section${alt ? ' discovery-section--alt' : ''}`} id={id}>
			<div className="container">
				<div className="discovery-section__header">
					<div>
						{eyebrow && <p className="discovery-section__eyebrow">{eyebrow}</p>}
						<h2 className="discovery-section__title">{title}</h2>
						{intro && <p className="discovery-section__intro">{intro}</p>}
					</div>
					{linkTo && linkLabel && (
						<Link to={linkTo} className="discovery-section__link">{linkLabel} →</Link>
					)}
				</div>
				{children}
			</div>
		</section>
	);
}

export default DiscoverySection;
